export default {
  locale:
  localStorage.getItem("locale") != null
      ? localStorage.getItem("locale")
      : "en",
  companyList: [],
  activeCompany:
  localStorage.getItem("activeCompany") != null
      ? localStorage.getItem("activeCompany")
      : null,
};
